import React from 'react';
import { Box, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const VehicleModelLocationDetailsSkeleton = () => (
  <Box py={3}>
    <Skeleton variant="rectangular" height={45} width="40%" />
    <Grid container pt={2}>
      <Grid item xs={6}>
        <Skeleton variant="text" width="50%" />
        <Skeleton variant="text" width="80%" />
        <Skeleton variant="text" width="70%" />
      </Grid>
      <Grid item xs={6}>
        <Skeleton variant="text" width="50%" />
        <Skeleton variant="text" width="90%" />
        <Skeleton variant="text" width="70%" />
      </Grid>
    </Grid>
  </Box>
);
export { VehicleModelLocationDetailsSkeleton };
